import React, { useContext } from "react";
import { useSearchStore } from "./hooks/useSearchStore";
import { Chip, SvgIcon, useTheme } from "@mui/material";
import { icons } from "./utils/icons";
import { categoriesItems } from "./utils/categoriesItems";
import { SearchCategory } from "./components/category";
import { SearchFormContext } from "./search-form-core";

type CategoriesProps = {
    onCategoryClick: (category: string) => void;
    className?: string;
    activeCategory: string;
};

export const Categories = ({
    onCategoryClick,
    className,
    activeCategory
}: CategoriesProps) => {
    const { categories: categoriesCounts } = useContext(SearchFormContext);
    return (
        <div
            className={`flex flex-col gap-1 text-base font-semibold ${className}`}
        >
            {categoriesItems.map((category) => {
                const count = categoriesCounts[category.section] || 0;

                return (
                    <SearchCategory
                        key={category.section}
                        name={category.section}
                        count={count}
                        onClick={() => onCategoryClick(category.section)}
                        isActive={activeCategory === category.section}
                    >
                        {category.title}
                    </SearchCategory>
                );
            })}
        </div>
    );
};
